import * as THREE from "three"
import Experience from "./Experience/Experience.js"

import gsap from "gsap"

import "./style.css"
import { FlyControls, OrbitControls } from "three/examples/jsm/Addons.js"


//document.body.classList.remove('loading');
// Instantiate Experience
const experience = new Experience(document.querySelector("canvas.webgl"))

// Hamburger Menu
const hamburgerButton = document.getElementById("hamburgerButton")
hamburgerButton.addEventListener("click", () => {
    const menu = document.querySelector(".mobileButtonsListDiv")
    menu.classList.toggle("open")
})
//const mobileDiv = document.querySelector(".mobileDiv")

// Home Buttons
const homeButton = document.getElementById("homeButton")
homeButton.addEventListener("click", () => {
    window.location.href="/"
})

const homeButtonMobile = document.getElementById("homeButtonMobile")
homeButtonMobile.addEventListener("click", () => {
    window.location.href="/"
})

// Animation Buttons
const animationButton = document.getElementById("animationButton")
animationButton.addEventListener("click", () =>{
    const targetObject = experience.world.planetAnimation.planetGroup
    clickSection("animationDiv", targetObject, -20, 3, 30, -8)
})

const animationButtonMobile = document.getElementById("animationButtonMobile")
animationButtonMobile.addEventListener("click", () =>{
    const targetObject = experience.world.planetAnimation.planetGroup
    clickSection("animationDiv", targetObject, -20, 3, 30, -8)
})

const animationPageButton = document.getElementById("animation3DButton")
animationPageButton.addEventListener("click", () =>{
    window.location.href = "/portfolio-gallery.html"
})

const simulationPageButton = document.getElementById("animationSimButton")
simulationPageButton.addEventListener("click", () =>{
    window.location.href = "/portfolio-gallery.html"
})

const interactivePageButton = document.getElementById("animationInteractiveButton")
interactivePageButton.addEventListener("click", () =>{
    window.location.href = "/portfolio-gallery.html"
})

const postPageButton = document.getElementById("animationPostButton")
postPageButton.addEventListener("click", () =>{
    window.location.href = "/portfolio-gallery.html"
})

// const observePlanetAnimationButton = document.getElementById("observePlanetAnimationButton")
// observePlanetAnimationButton.addEventListener("click", ()=>{
    
//     const targetObject = experience.world.planetAnimation.planetGroup
//     observePlanet(targetObject)
    
//     // console.log(experience.camera.controls)
//     // enableFlyControls()
//     // console.log(experience.camera.controls)
// })


// Photography Buttons
const photographyButton = document.getElementById("photographyButton")
photographyButton.addEventListener("click", () => {
    const targetObject = experience.world.planetPhotography.planetGroup
    clickSection("photographyDiv", targetObject, 0, 6, 40, -5)
})

const photographyButtonMobile = document.getElementById("photographyButtonMobile")
photographyButtonMobile.addEventListener("click", () => {
    const targetObject = experience.world.planetPhotography.planetGroup
    clickSection("photographyDiv", targetObject, 0, 6, 40, -5)
})

const petsButton = document.getElementById("photographyPetButton")
petsButton.addEventListener("click", () => {
    window.location.href="/photography.html#petSection"
})

const peopleButton = document.getElementById("photographyPeopleButton")
peopleButton.addEventListener("click", () => {
    window.location.href="/photography.html#peopleSection"
})

const productsButton = document.getElementById("photographyProductButton")
productsButton.addEventListener("click", () => {
    window.location.href="/photography.html#productSection"
})

// Contact Buttons
const contactButton = document.getElementById("contactButton")
contactButton.addEventListener("click", () => {
    const targetObject = experience.world.planetContact.planetGroup
    clickSection("contactDiv", targetObject, 0, -3, 20, -3)
})

const contactButtonMobile = document.getElementById("contactButtonMobile")
contactButtonMobile.addEventListener("click", () => {
    const targetObject = experience.world.planetContact.planetGroup
    clickSection("contactDiv", targetObject, 0, -3, 20, -3)
})

// YouTube Button
const youtubeButton = document.getElementById("youtubeButton")
youtubeButton.addEventListener("click", () => {
    window.open("https://youtube.com/bogusindustries", "_blank")
})

// Instagram Button
const instagramButton = document.getElementById("instagramButton")
instagramButton.addEventListener("click", () => {
    window.open("https://instagram.com/bogusindustries", "_blank")
})

// LinkedIn Button
const linkedinButton = document.getElementById("linkedinButton")
linkedinButton.addEventListener("click", () => {
    window.open("https://www.linkedin.com/in/therealjz/", "_blank")
})

// Email Button
const emailButton = document.getElementById("emailButton")
emailButton.addEventListener("click", () => {
    window.location.href = "mailto:johnzilka@gmail.com?subject=Nice%20Website&body=Hey!%20I'd%20like%20to%20know%20more%20about...";
})

// About Buttons
const aboutButton = document.getElementById("aboutButton")
aboutButton.addEventListener("click", () =>{
    const targetObject = experience.world.sun.mesh
    clickSection("aboutDiv", targetObject, 3, 3, 10, 0)
})

const aboutButtonMobile = document.getElementById("aboutButtonMobile")
aboutButtonMobile.addEventListener("click", () =>{
    const targetObject = experience.world.sun.mesh
    clickSection("aboutDiv", targetObject, 3, 3, 10, 0)
})

const bioButton = document.getElementById("bioButton")
bioButton.addEventListener("click", () =>{
    window.location.href="/about.html"
})

//educationButton
const educationButton = document.getElementById("educationButton")
educationButton.addEventListener("click", () =>{
    window.location.href="/about.html"
})

//resumeButton
const resumeButton = document.getElementById("resumeButton")
resumeButton.addEventListener("click", () =>{
    window.location.href="/about.html"
})

// Blog Button
const blogButton = document.getElementById("blogButton")
blogButton.addEventListener("click", () => {
    window.location.href="/blog.html"
})

const blogButtonMobile = document.getElementById("blogButtonMobile")
blogButtonMobile.addEventListener("click", () => {
    window.location.href="/blog.html"
})

// Lab Buttons
const labButton = document.getElementById("labButton")
labButton.addEventListener("click", () =>{
    const targetObject = experience.world.planetLab.planetGroup
    clickSection("labDiv", targetObject, -20, 3, 30, -8)
})

const labButtonMobile = document.getElementById("labButtonMobile")
labButtonMobile.addEventListener("click", () =>{
    const targetObject = experience.world.planetLab.planetGroup
    clickSection("labDiv", targetObject, -20, 3, 30, -8)
})

const randomRecipeButton = document.getElementById("randomRecipeButton")
randomRecipeButton.addEventListener("click", ()=>{
    window.location.href="/random-recipe.html"
})

// Control Buttons
const toggleCameraControlsButton = document.getElementById("toggleCameraControlsButton")
if(toggleCameraControlsButton){
    toggleCameraControlsButton.addEventListener("click", ()=>{
        console.log("toggle camera controls")
        if(experience.camera.controls instanceof OrbitControls){
            experience.camera.setFlyControls()
        }
        else if (experience.camera.controls instanceof FlyControls){
            experience.camera.setOrbitControls()
        }
    })
}

// Moves camera to targetObject plus offset values
// Moves camera aim target to targetObject plus rotOffsetY
// triggers fadeIn animation on sectionId which is a div
const clickSection = (sectionId, targetObject, posOffsetX, posOffsetY, posOffsetZ, rotOffsetY)=>{
    //console.log("main script click section")
    hideAllSections()

    const transitionCamera = () =>{
        gsap.to(experience.camera.instance.position, {
            x: targetObject.position.x + posOffsetX,
            y: targetObject.position.y + posOffsetY,
            z: targetObject.position.z + posOffsetZ,
            duration:5,
            ease: "power2.inOut",
            onComplete: () =>{
                document.getElementById(sectionId).style.visibility = "visible"
                document.getElementById(sectionId).style.animation = "fadeIn 1s ease 0s 1 forwards"
            }
        })

        gsap.to(experience.camera.controls.target,{
            x: targetObject.position.x + rotOffsetY,
            y: targetObject.position.y,
            z: targetObject.position.z,
            duration: 4,
            ease: "power2.inOut",
            onUpdate: ()=>{
                experience.camera.controls.update()
            }
        })
    }

    if(experience.camera.controls instanceof OrbitControls){
        transitionCamera()
        // gsap.to(experience.camera.instance.position, {
        //     x: targetObject.position.x + posOffsetX,
        //     y: targetObject.position.y + posOffsetY,
        //     z: targetObject.position.z + posOffsetZ,
        //     duration:5,
        //     ease: "power2.inOut",
        //     onComplete: () =>{
        //         document.getElementById(sectionId).style.visibility = "visible"
        //         document.getElementById(sectionId).style.animation = "fadeIn 1s ease 0s 1 forwards"
        //     }
        // })

        // gsap.to(experience.camera.controls.target,{
        //     x: targetObject.position.x + rotOffsetY,
        //     y: targetObject.position.y,
        //     z: targetObject.position.z,
        //     duration: 4,
        //     ease: "power2.inOut",
        //     onUpdate: ()=>{
        //         experience.camera.controls.update()
        //     }
        // })
    }
    else if (experience.camera.controls instanceof FlyControls){
        experience.camera.setOrbitControls()
        transitionCamera()
        // gsap.to(experience.camera.instance.position, {
        //     x: targetObject.position.x + posOffsetX,
        //     y: targetObject.position.y + posOffsetY,
        //     z: targetObject.position.z + posOffsetZ,
        //     duration:5,
        //     ease: "power2.inOut",
        //     onComplete: () =>{
        //         document.getElementById(sectionId).style.visibility = "visible"
        //         document.getElementById(sectionId).style.animation = "fadeIn 1s ease 0s 1 forwards"
        //     }
        // })

        // gsap.to(experience.camera.controls.target,{
        //     x: targetObject.position.x + rotOffsetY,
        //     y: targetObject.position.y,
        //     z: targetObject.position.z,
        //     duration: 4,
        //     ease: "power2.inOut",
        //     onUpdate: ()=>{
        //         experience.camera.controls.update()
        //     }
        // })
    }
    
}

const observePlanet = (targetObject) =>{
    hideAllSections()
    gsap.to(experience.camera.controls.target,{
        x: targetObject.position.x,
        y:targetObject.position.y,
        z: targetObject.position.z,
        duration: 2,
        ease: "power2.inOut",
        onUpdate: ()=>{
            experience.camera.controls.update()
        }
    })
    // this will make the aim follow the target
    //experience.camera.controls.target = experience.world.moonAnimationAnimation.mesh.position
}

// Turns all planet pop up menus off
const hideAllSections = ()=>{
    const sections = ["animationDiv", "photographyDiv", "aboutDiv", "contactDiv", "labDiv"]
    sections.forEach((sectionId)=>{
        const element = document.getElementById(sectionId)
        element.style.animation = "fadeOut 1s ease 0s forwards"
        element.addEventListener("animationend", (event)=>{
            if(event.animationName === "fadeOut"){
                element.style.visibility = "hidden"
            }
        }, {once: true})
    })
}

// Exit buttons on all planet popup menus
const closePopupButtons = document.querySelectorAll(".rightSideButton")

// Listen for click, when heard, close all popup menus
closePopupButtons.forEach((button) =>{
    button.addEventListener("click", () =>{
        hideAllSections()
    })
})

const enableFlyControls = () =>{
    experience.camera.setFlyControls()
}

// Refactor Deletion
//const instructions = document.getElementById("instructions")

// responsive hamburger menu stuff



// Raycaster
const raycaster = new THREE.Raycaster()


// Mouse
const mouse = new THREE.Vector2()


window.addEventListener("mousemove", (e) =>{
    mouse.x = e.clientX / experience.sizes.width * 2 - 1
    mouse.y = -(e.clientY / experience.sizes.height) * 2 + 1
})

// let currentIntersect
// // Clickable Objects
// const clickable = [
//     sunMesh, 
//     contactMesh, 
//     planetPhotography, 
//     planetAnimation
// ]

// Handles 3D object clicking
// prevent raycasting till first click
// let raycastEnabled = false
// window.addEventListener("mousedown", () => {
//     raycastEnabled = true
//     if (currentIntersect){
//         switch(currentIntersect.object){
//             case sunMesh:
//                 clickAbout(sunMesh)
//                 break
//             case contactMesh:
//                 clickContacts(contactMesh)
//                 break
//             case planetPhotography:
//                 clickPhotography(planetPhotography)
//                 break
//             case planetAnimation:
//                 clickAnimation(planetAnimation)
//                 break
//             default:
//                 break
//         }
//     }
// })

// Refactor Deletion
// function hideAllSections() {
//     const sections = ["aboutDiv", "contactDiv", "photographyDiv", "animationDiv"]
//     sections.forEach(sectionId => {
//         //document.getElementById(sectionId).style.animation="fadeOut 1s ease 0s 1 forwards";
//         //document.getElementById(sectionId).style.visibility = "hidden";
//         const element = document.getElementById(sectionId)
//         element.style.animation="fadeOut 1s ease 0s 1 forwards"
//         element.addEventListener("animationend", function(event){
//             if(event.animationName ==="fadeOut"){
//                 element.style.visibility="hidden"
//             }
//         }, {once: true})
//     })
// }

// function clickSection(sectionId, targetObject, posOffsetX, posOffsetY, posOffsetZ, rotOffsetY) {
//     console.log("click Selection")
//     hideAllSections() // Hide all sections before showing the target one

//     // Set section visibility
//     //document.getElementById(sectionId).style.visibility = "visible"

//     // Animate camera position with GSAP
//     //Refactor Deletion
//     // gsap.to(camera.position, {
//     //     x: targetObject.position.x + posOffsetX,
//     //     y: targetObject.position.y + posOffsetY,
//     //     z: targetObject.position.z + posOffsetZ,
//     //     duration: 5,
//     //     ease: "power2.inOut",
//     //     onComplete: function(){
//     //         document.getElementById(sectionId).style.visibility = "visible"
//     //         document.getElementById(sectionId).style.animation="fadeIn 1s ease 0s 1 forwards"
//     //     }
//     // })
    
//     // Refactor Deletion
//     // gsap.to(orbitControls.target,{
//     //     x: targetObject.position.x + rotOffsetY,
//     //     y: targetObject.position.y,
//     //     z: targetObject.position.z,
//     //     duration: 4,
//     //     ease: "power2.inOut",
//     //     onUpdate: function(){
//     //         orbitControls.update()
//     //     }
//     // })
// }

// function clickAbout(targetObject){
//     console.log("Click About")
//     //clickSection("aboutDiv", targetObject, 3, 3, 10, 0)
// }

// function clickContacts(targetObject){
//     console.log("Click Contacts")
//     //clickSection("contactDiv", targetObject, 0, -3, 20, -3)
// }

// function clickPhotography(targetObject){
//     console.log("clicked photography")
//     //clickSection("photographyDiv", targetObject, 0, 6, 40, -10)
// }

// function clickAnimation(targetObject){
//     console.log("clicked animation - disabled function")
//     //clickSection("animationDiv", targetObject, -20, 3, 30, -8)
// }

// HTML button functions

// document.getElementById("hamburgerDiv").addEventListener("click", function(){
//     if(menu != null){
//         menu.classList.toggle("open")
//     }
// })


// hamburgerButton.addEventListener("click", () => {
//     mobileDiv.classList.toggle("active")
// })

// document.getElementById("hamburgerButton").addEventListener("click", function(){
//     console.log("clicked hamburger")
//     const menu = document.querySelector(".mobileButtonsListDiv")
//     menu.classList.toggle("open")
// })

// document.getElementById("homeButton").addEventListener("click", function(){
//     window.location.href="/"
// })

// document.getElementById("homeButtonMobile").addEventListener("click", function(){
//     window.location.href="/"
// })

// document.getElementById("animationButton").addEventListener("click", function(){
//     clickAnimation(planetAnimation)
// })

// document.getElementById("animationButtonMobile").addEventListener("click", function(){
//     clickAnimation(planetAnimation)
// })

// document.getElementById("photographyButton").addEventListener("click", function(){
//     clickPhotography(planetPhotography)
// })

// document.getElementById("photographyButtonMobile").addEventListener("click", function(){
//     clickPhotography(planetPhotography)
// })

// document.getElementById("blogButton").addEventListener("click", function(){
//     window.location.href="/blog.html"
// })

// document.getElementById("blogButtonMobile").addEventListener("click", function(){
//     window.location.href="/blog.html"
// })

// document.getElementById("contactButton").addEventListener("click", function(){
//     clickContacts(contactMesh)
// })

// document.getElementById("contactButtonMobile").addEventListener("click", function(){
//     clickContacts(contactMesh)
// })

// document.getElementById("aboutButton").addEventListener("click", function(){
//     clickAbout(sunMesh)
// })

// document.getElementById("aboutButtonMobile").addEventListener("click", function(){
//     clickAbout(sunMesh)
// })

// document.getElementById("bioButton").addEventListener("click", function(){
//     window.location.href="/about.html"
// })

// document.getElementById("photographyPetButton").addEventListener("click", function(){
//     window.location.href="/photography.html#pets"
// })

// document.getElementById("photographyPeopleButton").addEventListener("click", function(){
//     window.location.href="/photography.html#people"
// })
// document.getElementById("photographyProductButton").addEventListener("click", function(){
//     window.location.href="/photography.html#products"
// })

// document.getElementById("animation3DButton").addEventListener("click", function(){
//     window.location.href="/animation-3d.html"
// })
// document.getElementById("animationSimButton").addEventListener("click", function(){
//     window.location.href="/animation-3d.html"
// })
// document.getElementById("animation2DButton").addEventListener("click", function(){
//     window.location.href="/animation-3d.html"
// })
// document.getElementById("youtubeButton").addEventListener("click", function(){
//     //window.location.href="/contact.html"
//     window.open("https://youtube.com/bogusindustries", "_blank")
// })

// document.getElementById("instagramButton").addEventListener("click", function(){
//     //window.location.href="/contact.html"
//     window.open("https://instagram.com/bogusindustries", "_blank")
// })

// document.getElementById("linkedinButton").addEventListener("click", function(){
//     //window.location.href="/contact.html"
//     window.open("https://www.linkedin.com/in/therealjz/", "_blank")
// })

// document.getElementById("emailButton").addEventListener("click", function() {
//     window.location.href = "mailto:johnzilka@gmail.com?subject=Nice%20Website&body=Hey!%20I'd%20like%20to%20know%20more%20about...";
// })

// const closeButtons = document.querySelectorAll(".rightSideButton")
// closeButtons.forEach(button =>{
//     button.addEventListener("click", function(){
//         console.log("close Button clicked")
//         hideAllSections()
//     })
// })
